/**
 *功能: 渤化接口
 */
export default {
  $getway: 'OurwayBoHua',
  getGoodsName: '/getGoodsName',
  webCusInGoods:'/webCusInGoods',
  webCusGoods:'/webCusGoods',
  webCusfinancialset:'/webCusfinancialset',
  webCusInOutDay:'/webCusInOutDay',
  webCusOutGoods:'/webCusOutGoods',
  listGuestDic: 'query/listGuestDic',
  webQryShipInOut: 'query/webQryInOutShip',
  listGoodsDic: 'query/listGoodsDic',
};
